import React from 'react';


export function Table(props) {



    return (
        <table className={"table table-striped "+ (props.classes != null ? props.classes  : " table-secondary")}>
            <thead>
            {props.headers}
            </thead>

            <tbody>
                {props.children}
            </tbody>
        </table>
    );


}